/**
 * Homepage header state, following Missoma: the bar sits translucent over
 * the hero while the page is at the top, and turns solid once the reader
 * has scrolled more than 150px.
 *
 * Hover, keyboard focus and an open menu also make it solid, but those are
 * handled in CSS so they respond instantly rather than on a scroll event.
 * This script only toggles a class; every visual lives in
 * component-header-overlay.css.
 *
 * No requestAnimationFrame throttle: toggling a class to the state it
 * already has changes nothing, and the browser batches the restyle into its
 * next frame on its own. A rAF wrapper only made the state wait on frames
 * being painted.
 */
(function () {
  if (!document.body.classList.contains('template-index')) return;

  const section = document.querySelector('.section-header');
  if (!section) return;

  const THRESHOLD = 150;

  const update = () => {
    section.classList.toggle('section-header--solid', window.scrollY > THRESHOLD);
  };

  window.addEventListener('scroll', update, { passive: true });

  // A reload mid-page restores the scroll position before this runs.
  update();
})();
